import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = {
  colspan: "2",
  class: "text-center"
}
const _hoisted_6 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          class: "d-flex justify-center align-center"
        }, {
          default: _withCtx(() => [
            (!_ctx.miscellaneousMode)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "3",
                  class: "d-flex flex-row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_text_field_filled, {
                      "append-inner-icon": "$euro",
                      modelValue: _ctx.docFilter.amount.minimum,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.docFilter.amount.minimum) = $event)),
                      label: "Min",
                      class: "amount-filter margin"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_oss_text_field_filled, {
                      "append-inner-icon": "$euro",
                      modelValue: _ctx.docFilter.amount.maximum,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.docFilter.amount.maximum) = $event)),
                      label: "Max",
                      class: "amount-filter margin ml-1"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _createVNode(_component_oss_date_picker_filled, {
                  multiple: "range",
                  begin: _ctx.docFilter.date.begin,
                  end: _ctx.docFilter.date.end,
                  dense: true,
                  class: "ml-1",
                  "hide-details": "",
                  onChangeDateRange: _ctx.onDocDateRangeChanged
                }, null, 8, ["begin", "end", "onChangeDateRange"])
              ]),
              _: 1
            }),
            (!_ctx.thirdPartyCompanyId)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.docFilter.search,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.docFilter.search) = $event)),
                      "append-inner-icon": "$search",
                      label: "Recherche",
                      class: "ml-1"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, { cols: "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_icon, {
                  class: "ml-1",
                  disabled: _ctx.isFiltered(_ctx.defaultDocFilter, _ctx.docFilter),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.clearDocFilters()), ["stop"])),
                  icon: "$delete"
                }, null, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table_server, {
          headers: _ctx.tableHeaders,
          items: _ctx.tableItems,
          expanded: _ctx.documentExpanded,
          "onUpdate:expanded": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.documentExpanded) = $event)),
          page: _ctx.docFilter.pagination.page,
          "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.docFilter.pagination.page) = $event)),
          "sort-by": _ctx.docFilter.pagination.sortBy,
          "onUpdate:sortBy": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.docFilter.pagination.sortBy) = $event)),
          "sort-desc": _ctx.docFilter.pagination.descending,
          "onUpdate:sortDesc": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.docFilter.pagination.descending) = $event)),
          "items-per-page": _ctx.docFilter.pagination.rowsPerPage,
          "onUpdate:itemsPerPage": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.docFilter.pagination.rowsPerPage) = $event)),
          "items-length": _ctx.docFilter.pagination.totalItems,
          "items-per-page-options": [5, 10, 25],
          class: "table",
          "fixed-header": "",
          "max-height": "60vh"
        }, {
          item: _withCtx((props) => [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.name), 1),
              _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.date ? props.item.date : "-"), 1),
              (!_ctx.miscellaneousMode)
                ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(props.item.debit
                                    ? _ctx.newCommonFormatCurrency(props.item.debit, undefined)
                                    : "-"), 1))
                : _createCommentVNode("", true),
              (!_ctx.miscellaneousMode)
                ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(props.item.credit
                                    ? _ctx.newCommonFormatCurrency(props.item.credit, undefined)
                                    : "-"), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        (props.item.signedUrl)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              onClick: _withModifiers(($event: any) => {
                                            _ctx.addRemoveDocumentExpand(props.item);
                                            props.toggleExpand(props.internalItem);
                                        }, ["stop"]),
                              icon: "$oss-eye",
                              size: "x-small"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!props.item.selected)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              rounded: "",
                              class: "btn ml-1",
                              dense: "",
                              onClick: _withModifiers(($event: any) => (
                                            _ctx.miscellaneousMode
                                                ? _ctx.addDocument(props.item)
                                                : _ctx.addAccountingLine(props.item)
                                        ), ["stop"]),
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode(" Ajouter ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ])
            ])
          ]),
          "expanded-row": _withCtx(({ columns, item }) => [
            _createElementVNode("td", {
              colspan: columns.length
            }, [
              (item.signedUrl)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    align: "center",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: item.signedUrl,
                        "lazy-src": _imports_0,
                        "max-width": "50vw",
                        contain: true,
                        class: "elevation-5 my-4"
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6)
          ]),
          _: 1
        }, 8, ["headers", "items", "expanded", "page", "sort-by", "sort-desc", "items-per-page", "items-length"])
      ]),
      _: 1
    })
  ]))
}